import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const UserDashboard = () => {
  const [activeTab, setActiveTab] = useState('upcoming');
  const [bookingRef, setBookingRef] = useState('');

  const appointments = [
    {
      id: 1,
      doctorName: 'Dr. Rajesh Kumar',
      specialty: 'Dentist',
      date: '2026-02-05',
      time: '10:00 AM',
      status: 'confirmed',
      fee: 500,
      ref: 'DOC123ABC'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-6xl mx-auto px-6">
        <h1 className="text-3xl font-bold text-[#19354a] mb-8">My Appointments</h1>

        {/* Track Appointment */}
        <div className="bg-white rounded-xl shadow-md p-6 mb-6">
          <h2 className="text-xl font-bold text-[#19354a] mb-4">Track Appointment</h2>
          <div className="flex gap-4">
            <input
              type="text"
              placeholder="Enter Booking Reference Number"
              value={bookingRef}
              onChange={(e) => setBookingRef(e.target.value)}
              className="flex-1 px-4 py-3 border rounded-lg focus:border-[#39a5d3] focus:outline-none"
            />
            <button className="px-6 py-3 bg-[#E85A2C] text-white rounded-lg font-semibold hover:bg-[#d64d1f]">
              Track
            </button>
          </div>
        </div>

        {/* Tabs */}
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
          <div className="border-b flex">
            {['upcoming', 'past', 'cancelled'].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`flex-1 px-6 py-4 font-semibold capitalize ${
                  activeTab === tab
                    ? 'text-[#39a5d3] border-b-2 border-[#39a5d3]'
                    : 'text-gray-600'
                }`}
              >
                {tab} Appointments
              </button>
            ))}
          </div>

          <div className="p-6">
            {appointments.length > 0 ? (
              appointments.map((apt) => (
                <div key={apt.id} className="border rounded-lg p-6 mb-4">
                  <div className="flex justify-between items-start mb-4">
                    <div>
                      <h3 className="font-bold text-lg text-[#19354a]">{apt.doctorName}</h3>
                      <p className="text-[#39a5d3]">{apt.specialty}</p>
                    </div>
                    <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm font-semibold">
                      {apt.status}
                    </span>
                  </div>
                  <div className="grid md:grid-cols-3 gap-4 mb-4">
                    <div>
                      <p className="text-sm text-gray-600">Date</p>
                      <p className="font-semibold">{apt.date}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">Time</p>
                      <p className="font-semibold">{apt.time}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">Booking Ref</p>
                      <p className="font-semibold">{apt.ref}</p>
                    </div>
                  </div>
                  <div className="flex gap-3">
                    <button className="px-4 py-2 border-2 border-[#39a5d3] text-[#39a5d3] rounded-lg hover:bg-[#39a5d3] hover:text-white">
                      Reschedule
                    </button>
                    <button className="px-4 py-2 border-2 border-red-500 text-red-500 rounded-lg hover:bg-red-500 hover:text-white">
                      Cancel
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center text-gray-600 py-12">No appointments found</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;
